import React, { createContext, useContext } from "react";
import { notification } from "antd";

const NotificationContext = createContext();

export const notificationConfig = {
  showProgress: false,
  duration: 1.5,
  maxCount: 2,
  pauseOnHover: false,
  closeIcon: null,
  style: { padding: "0" },
};

export const NotificationProvider = ({ children }) => {

  const [api, contextHolder] = notification.useNotification(notificationConfig);

  return (
    <NotificationContext.Provider value={api}>
      {children}
      {contextHolder}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error(
      "useNotification must be used within a NotificationProvider",
    );
  }
  return context;
};

export default NotificationContext;
